module.exports = {
  env: {},
  browser: true,
  versions: {
    node: "1000.0.0",
  },
  cwd() {
    return "/"
  }
}